export enum ViewTypeEnum {
  Star = 1,
}
